import { VENDOR_LIST, VENDOR_ONLY_LIST } from "../../actionTypes/admin";

const intialState = {
  vendorList: [],
  vendorOnlyList: []
};

export default function VendorReducers(state = intialState, action) {
  switch (action.type) {

    case VENDOR_LIST:
      return { ...state, vendorList: action.payload };

    case VENDOR_ONLY_LIST:
      return { ...state, vendorOnlyList: action.payload };

    default:
      return state;
  }
}
